import axiosInstance from "./axios";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const triggerSynkkaImport = async (
    bearerToken: string,
    synkkaId: string,
): Promise<void> => {
    try {
        await axiosInstance.post(
            `${apiUrl}/Admin/synkka/import/${synkkaId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${bearerToken}`,
                },
            },
        );
    } catch (error) {
        console.error("Failed to trigger Synkka import:", error);
        throw error;
    }
};

export const triggerUserSynkkaImport = async (
    bearerToken: string,
    companyId: number,
): Promise<void> => {
    try {
        await axiosInstance.post(
            `${apiUrl}/companies/${companyId}/synkka/import`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${bearerToken}`,
                },
            },
        );
    } catch (error) {
        console.error("Failed to trigger Synkka import:", error);
        throw error;
    }
};
